import { isDesktop } from './device';
import amaLog from '../helpers/log';
import { resolveCountryCode, getDomain } from './domain';
/////////////////
////////////////////////////////////////////////
/////////



export const seenthis = (adUnitPath: string, domId: string) => {
  window.highImpactJs = window.highImpactJs || {
    cmd: [],
  };

  const sizes = isDesktop() ? [[1920, 1080]] : [[1080, 1920]];

  const addMidScrollScript = () => {
    window.highImpactJs.cmd.push(() => {
      window.highImpactJs.defineSlot({
        slot: adUnitPath,
        template: 'midscroll',
        sizes: sizes,
        adUnitId: domId,
        waitForAdSignal: true,
      });
    });
  };

  const isTopAds = domId.includes('top_ad');
  const dkDomainsWithoutTopBar = ["femina.dk", "udeoghjemme.dk", "isabellas.dk", "vielskerserier.dk"];
  const domain = getDomain();
  const topBarHeight = isDesktop() || dkDomainsWithoutTopBar.includes(domain) ? 0 : 60;
  if (isTopAds) {
    window.highImpactJs.cmd.push(() => {
      window.highImpactJs.setConfig({
        topBarHeight: topBarHeight,
        plugins: ['gam'],
        zIndex: 199,
      });

      window.highImpactJs.setTemplateConfig('topscroll', {
        topBarHeight: topBarHeight,
        peekAmount: '70vh',
        adLabel: {
          content: resolveCountryCode() === 'dk' ? "Annonce" : "Annons",
          css: "position: absolute;display: flex;justify-content: space-between;height: 36px;width: 100%;line-height: 36px;background-color: white;z-index: 200;text-align: center;cursor: pointer;font-size: 0.75rem;font-family: 'Helvetica';color: #8d8d8d;padding-left:10px;",
        }
      });

      window.highImpactJs.defineSlot({
        slot: adUnitPath,
        template: 'topscroll',
        sizes: sizes,
        adUnitId: domId,
        waitForAdSignal: true,
      });
    });

    addSeenthisStyle();
  } else {
    addMidScrollScript();
  }
  topMidscrollerHandling(domId);
};

const addSeenthisStyle = () => {

  let customStyles = '';

///////////////////
////////////////////////////////////
///////////

  const seenthisStyle = document.createElement('style');
  seenthisStyle.textContent = `
    body.high-impact-topscroll-rendered #__next {
      position: relative !important;
    }
    body.high-impact-topscroll-rendered:not(.high-impact-topscroll-is-hidden) #top-nav {
      position: absolute;
      max-height: unset !important;
    }
    ${customStyles}
  `;
  document.head.appendChild(seenthisStyle);
};

const topMidscrollerHandling = (domId: string) => {

  const targetDiv = document.getElementById(domId) as HTMLElement | null;
  if (!targetDiv) return;

  const observer = new MutationObserver((mutations) => {
    if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'class')) {
      handleClassList(targetDiv, observer);
    }
  });

  observer.observe(targetDiv, { attributes: true, attributeFilter: ['class'] });

  handleClassList(targetDiv, observer);
};

let foundTop = false;
let foundMid = false;

const handleClassList = (targetDiv: HTMLElement, observer: MutationObserver) => {

  const isMid = targetDiv.classList.contains('high-impact-ad-wrapper-midscroll');
  const isTop = targetDiv.classList.contains('high-impact-ad-wrapper-topscroll');

  if ((!foundMid && isMid) || (!foundTop && isTop)) {

    waitForJWWrappers().then((jwWrappers) => {
      if (jwWrappers.length > 0) {
        initTopMidscrollerVideoHide(targetDiv, jwWrappers);
      } else {
        amaLog('No jw-wrapper elements found after timeout');
      }
    }).catch((error) => {
      amaLog('No jw-wrapper elements found', error);
    });

    if (isMid) foundMid = true;
    if (isTop) foundTop = true;
    if (foundMid && foundTop) {
      observer.disconnect();
      amaLog('Both top and midscroller initialized, disconnecting observer');
    }
  }
}

const waitForJWWrappers = (timeoutMs = 10000): Promise<HTMLElement[]> => {
  return new Promise((resolve, reject) => {
    const findElements = () =>
      Array.from(document.querySelectorAll<HTMLElement>('.jw-wrapper'));

    // 1) Immediate check
    const existing = findElements();
    if (existing.length > 0) {
      amaLog('waitForJWWrappers - Found immediately');
      return resolve(existing);
    }

    // 2) Setup observer
    const observer = new MutationObserver((mutations, obs) => {
      for (const mutation of mutations) {
        for (const node of Array.from(mutation.addedNodes)) {
          if (
            node instanceof HTMLElement &&
            (node.matches('.jw-wrapper') || node.querySelector('.jw-wrapper'))
          ) {
            amaLog('waitForJWWrappers - Found via MutationObserver');
            obs.disconnect();
            clearTimeout(timer);
            return resolve(findElements());
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const timer = setTimeout(() => {
      observer.disconnect();
      reject(new Error('jw-wrapper not found within timeout'));
    }, timeoutMs);
  });
};


const initTopMidscrollerVideoHide = (adUnitDiv: HTMLElement, jwWrappers: HTMLElement[]) => {
  amaLog('SeenthisMidscroller - Video hiding for ', jwWrappers);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        jwWrappers.forEach((el: HTMLElement) => {
          el.style.opacity = entry.isIntersecting ? '0' : '1';
        });
      });
    },
    { threshold: 0 },
  );

  jwWrappers.forEach((el: HTMLElement) => {
    el.style.setProperty('transition', 'opacity 0.5s ease 0s', 'important');
  });

  observer.observe(adUnitDiv);
};
